<div class="container">
  <div class="admin-page-header">
    <h1 class="admin-page-title">{{'finance.payment.title'|traduccion}}</h1>
    <div class="summary-chip">{{'finance.payment.totalElements'|traduccion}}: {{payments.totalElements}}</div>
  </div>

  <mat-card>
    <app-filter [filters]="fieldFilters" [accions]="accions" [massiveAccions]="massiveAccions" [loading]="state === 'loading'" btLabel="Buscar"
      (submit)="submit($event)" (massiveAction)="onClickMassiveAction($event)"
      (massiveActionChanged)="onChangeMassiveActionSelected($event)"></app-filter>
  </mat-card>

  <mat-card>
    <div>
      {{'finance.payment.totalInvoiced'|traduccion}}: {{ resumen.total|currency }}
    </div>
  </mat-card>

  <div class="table-container">
    <ng-container [ngSwitch]="state">
      <div *ngSwitchCase="'idle'" class="placeholder">
        <mat-icon>search</mat-icon>
        <div [innerHTML]="'finance.payment.table.idle'|traduccion"></div>
      </div>

      <div *ngSwitchCase="'loading'" class="placeholder">
        <mat-progress-spinner mode="indeterminate" diameter="28"></mat-progress-spinner>
        <div>{{'finance.payment.table.loading'|traduccion}}</div>
      </div>

      <app-data-table
        *ngSwitchCase="'loaded'"
        preset="admin"
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [selectionColumn]="selectionColumnConfig"
        [actionColumn]="paymentActionColumn"
        [emptyMessage]="'finance.payment.table.nodata'|traduccion"
        [showPaginator]="true"
        [length]="totalElements"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[10, 25, 50]"
        [rowClickable]="true"
        (rowClick)="setOpen($event.row)"
        (selectionToggleAll)="masterToggle()"
        (selectionToggleRow)="selection.toggle($event)"
        (actionClick)="onPaymentTableAction($event)"
        (page)="onPageChange($event)">
        <ng-container matColumnDef="totalPrice">
          <th mat-header-cell *matHeaderCellDef>{{'finance.payment.table.header.totalPrice'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{ element.totalPrice | currency }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{'finance.payment.table.header.status'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">
            <app-data-table-badge
              [label]="element.status"
              [tone]="getPaymentStatusTone(element.status)">
            </app-data-table-badge>
          </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>{{'finance.payment.table.header.type'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">
            <app-data-table-badge
              [label]="element.type"
              [tone]="getPaymentTypeTone(element.type)">
            </app-data-table-badge>
          </td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>{{'finance.payment.table.header.createdAt'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{ element.createdAt | date: appService.FORMAT_DATETIME }}</td>
        </ng-container>

        <ng-container matColumnDef="invoiceNumber">
          <th mat-header-cell *matHeaderCellDef>{{'finance.payment.table.header.invoiceNumber'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{ element.invoiceNumber }}</td>
        </ng-container>
      </app-data-table>

      <div *ngSwitchCase="'error'" class="placeholder error">
        <mat-icon>error_outline</mat-icon>
        <div>
          {{'finance.payment.table.error'|traduccion}}
          <button mat-button color="primary" (click)="searchPayments()">{{'finance.payment.table.retry'|traduccion}}</button>
        </div>
      </div>
    </ng-container>
  </div>
</div>
